export const onboarding = {
  variants: {
    visible: { opacity: 1, x: 0 },
    hidden: { opacity: 0, x: -50 },
  },
  transition: {
    duration: 0.3,
  },
}
